import { useContext, useMemo, useRef } from "react";
import { useApolloClient } from "@apollo/client";
import { AgGridReact } from "ag-grid-react";
import { ProjectContext } from "context/ProjectProvider";
import AgGridPrintLayout from "pages/print-view-layout/ag-grid-print-layout";
import { ActivityLogPrintViewState } from "pages/print-view-layout/model";
import {
  getActivityLogColumnDefs,
  TActivityLogRow
} from "pages/reports-menu/audit-reports/activity-log/activity-log-columns";

function ActivityLogPrintView({ state }: { state: ActivityLogPrintViewState }) {
  const gridRef = useRef<AgGridReact<TActivityLogRow>>(null);
  const { gqlClientForProject } = useContext(ProjectContext);
  const subscriptionGqlClient = useApolloClient();

  const columnDefs = useMemo(
    () =>
      getActivityLogColumnDefs({
        showProjectName: !state.skipColumnIds?.includes("project_name")
      }),
    [state.skipColumnIds]
  );

  const rowData: TActivityLogRow[] = state.context?.rowData ?? [];

  return (
    <AgGridPrintLayout
      gridRef={gridRef}
      state={state}
      columnDefEntity={columnDefs}
      rowData={rowData}
      rowLoading={false}
      gqlClient={gqlClientForProject ?? subscriptionGqlClient}
    />
  );
}

export default ActivityLogPrintView;
